module.exports = __webpack_public_path__ + "static/media/javid.858bb308.jpeg";